<template>
  <div class="create-meeting-page">
    <CreateMedicationInstruction v-if="$auth.user().type === 0"/>
    <CreateOnline v-else/>
  </div>
</template>

<script>
import CreateOnline from '@/pages/Meeting/CreateOnline'
import CreateMedicationInstruction from '@/pages/Meeting/CreateMedicationInstruction'

export default {
  components: {
    CreateOnline,
    CreateMedicationInstruction
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Meeting/Create.vue